import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEqualLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4.09489 12.2918C3.78916 12.2918 3.5415 12.5717 3.5415 12.9168C3.5415 13.262 3.78916 13.5418 4.09489 13.5418H15.9048C16.2105 13.5418 16.4582 13.262 16.4582 12.9168C16.4582 12.5717 16.2105 12.2918 15.9048 12.2918H4.09489ZM4.09489 6.4585C3.78916 6.4585 3.5415 6.73832 3.5415 7.0835C3.5415 7.42868 3.78916 7.7085 4.09489 7.7085H15.9048C16.2105 7.7085 16.4582 7.42868 16.4582 7.0835C16.4582 6.73832 16.2105 6.4585 15.9048 6.4585H4.09489Z",
		fill: "currentColor"
	})
});
export default SvgEqualLine;
